
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"36"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"그룹 2105","fill":"none"}},[_c('path',{attrs:{"data-name":"사각형 647","d":"M0 36V0h36v36z"}}),_c('path',{attrs:{"data-name":"패스 242","d":"M16.5 14.5l4 4-4 4","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])])
          )
        }
      }
    